/**
 * 휴대폰 번호 도우미. 저장·전송은 모두 E.164(+국가번호) 형식으로 한다.
 * 서버와 화면이 함께 쓴다(비밀 값 없음).
 */

const E164 = /^\+[1-9]\d{7,14}$/;

/** E.164 형식인지 확인한다. 예: +821012345678 */
export function isE164PhoneNumber(value: string): boolean {
  return E164.test(value);
}

/**
 * 사람이 입력한 번호를 E.164 로 바꾼다. `+` 로 시작하지 않으면 한국 번호로 본다.
 * 예: "010-1234-5678" → "+821012345678". 바꿀 수 없으면 null.
 */
export function normalizePhoneNumber(input: string): string | null {
  const trimmed = input.trim();
  const digits = trimmed.replace(/[^\d]/g, "");
  if (!digits) return null;
  let candidate: string;
  if (trimmed.startsWith("+")) {
    candidate = `+${digits}`;
  } else if (digits.startsWith("0")) {
    candidate = `+82${digits.slice(1)}`;
  } else {
    candidate = `+${digits}`;
  }
  return isE164PhoneNumber(candidate) ? candidate : null;
}

/** 기록용으로 끝 4자리만 남긴다. 예: "****5678" */
export function maskPhoneNumber(phoneNumber: string): string {
  const digits = phoneNumber.replace(/[^\d]/g, "");
  return `****${digits.slice(-4)}`;
}
